import {
  VERTICAL_TYPES,
  LOGIN_FLOW_TYPES,
  AUTH_METHOD_TYPES,
  LOGIN_COMPONENTS,
  type VerticalType,
  type VerticalConfig,
} from '@constants/verticalConstants';

export const verticalConfigs: Record<VerticalType, VerticalConfig> = {
  [VERTICAL_TYPES.LEARN]: {
    vertical: VERTICAL_TYPES.LEARN,
    gatewayConfiguration: {
      productId: 1000,
      tenantId: 1,
    },
    branding: {
      logo: 'LearnLogo.svg',
      portalTitle: 'Learn Evaluator Portal',
    },
    theme: {
      primaryColor: '#6C47FF',
      secondaryColor: '#F5F3FF',
    },
    features: {
      login: {
        component: LOGIN_COMPONENTS.LOGIN_WITH_NUMBER,
        loginFlow: LOGIN_FLOW_TYPES.MOBILE_NUMBER,
        authMethod: AUTH_METHOD_TYPES.OTP,
      },
      dashboard: {
        evaluationPhases: true,
      },
      evaluation: {
        reportError: false,
        l1EvaluationReport: false,
        singleQuestionFlow: true,
        multiQuestionFlow: true,
        questionNavigation: true,
      },
    },
  },
  [VERTICAL_TYPES.META]: {
    vertical: VERTICAL_TYPES.META,
    gatewayConfiguration: {
      productId: 1000,
      tenantId: 2,
    },
    branding: {
      logo: 'MetaLogo.svg',
      portalTitle: 'Meta Evaluator Portal',
    },
    theme: {
      primaryColor: '#2563EB',
      secondaryColor: '#EFF6FF',
    },
    features: {
      login: {
        component: LOGIN_COMPONENTS.LOGIN_WITH_ADMISSION_NO,
        loginFlow: LOGIN_FLOW_TYPES.ADMISSION_ID,
        authMethod: AUTH_METHOD_TYPES.BOTH,
      },
      dashboard: {
        evaluationPhases: true,
      },
      evaluation: {
        reportError: true,
        l1EvaluationReport: true,
        singleQuestionFlow: true,
        multiQuestionFlow: true,
        questionNavigation: true,
      },
    },
  },
};
